<ng-template #chosenTemplate></ng-template>